(function(){
  'use strict';

  angular
    .module('app.news')
    .controller('NewsDetailsController', NewsDetailsController);

  function NewsDetailsController(API, $state, apiConfig, $filter) {
    let vm = this;

    vm.article = {};
    vm.newsCategories = [];
    vm.actualCategory = undefined;

    vm.isActualCategory = category => category == vm.actualCategory;
    vm.setActualCategory = category => vm.actualCategory = vm.isActualCategory(category) ? undefined : category;

    vm.$onInit = () => {
      _loadFromApi();
    }

    function _loadFromApi() {
      _loadNew();
      _loadCategories();
    }

    function _loadNew() {
      const slug = $state.params.slug;
      API.get(`post/${slug}`)
        .then(result => result.data)
        .then(article => {
          article = article ? article[0] : {};
          if(article.imagens){
            let image = article.imagens.find(image => image.principal_imagem);
            image = $filter('imgUrl')(image.nome_imagem);
            article.primaryImage = image;
          }
          if(article.videos){
            let video = article.videos.find(video => video.principal_video);
            article.primaryVideo = video.nome_video;
          }
          return article;
        })
        .then(article => vm.article = article)
        .catch(error => {
          console.log(error);
          $state.go('news');
        });
    }

    function _loadCategories() {
      API.get('categoria/57/destino')
        .then(result => result.data)
        .then(categories => vm.newsCategories = categories);
    }

	vm.submitNews = (news) => {
		API.post(`news`, news)
	   .then(result => swal('Enviado com sucesso!', '', 'success'))
	   .then(() => {
			angular.copy({}, news)
			vm.ItsOkayForm.$submitted = false;
			vm.ItsOkayForm.$setPristine();
	   })
	   .catch(error => {
			console.log(error, 'error');
			swal({title: 'Opss...!', text: 'Tente novamente!', type: 'error'}).then(() => $state.reload());
	   });
	}

  }

})();
